/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { NonNegativeInteger } from "@pagopa/ts-commons/lib/numbers";

/**
 * Payment amount range in cents
 */

// required attributes
const RangeR = t.interface({});

// optional attributes
const RangeO = t.partial({
  min: NonNegativeInteger,

  max: NonNegativeInteger
});

export const Range = t.intersection([RangeR, RangeO], "Range");

export type Range = t.TypeOf<typeof Range>;
